import { Link, TableCell, TableRow } from '@mui/material';
import React from 'react';

import { tableFilterOption } from '../../../styles/filters';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';

const MessageReportTableRow = ({
  errorMeaning = '',
  entryId = '',
  smsDate = '',
  type = '',
  userEmail = '',
  originator = '',
  dest_tn = '',
  country_code_name = '',
  status = '',
  clickToFilter = null,
  onClickMessage = null,
}) => {
  const rezonedDate = getZoneOffsettedDate(smsDate);

  return (
    <TableRow id={entryId}>
      <TableCell>
        <Link tabIndex={0} onClick={() => onClickMessage(entryId)}>
          {rezonedDate}
        </Link>
      </TableCell>
      <TableCell
        onClick={() => clickToFilter('typeFilter', type)}
        sx={tableFilterOption}
      >
        {type}
      </TableCell>
      <TableCell
        onClick={() => userEmail && clickToFilter('userFilter', userEmail)}
        sx={userEmail ? tableFilterOption : undefined}
      >
        {userEmail || 'N/A'}
      </TableCell>
      <TableCell
        onClick={() => originator && clickToFilter('fromFilter', originator)}
        sx={originator ? tableFilterOption : undefined}
      >
        {originator || 'N/A'}
      </TableCell>
      <TableCell
        onClick={() => dest_tn && clickToFilter('toFilter', dest_tn)}
        sx={dest_tn ? tableFilterOption : undefined}
      >
        {dest_tn || 'N/A'}
      </TableCell>
      <TableCell>{country_code_name || 'N/A'}</TableCell>
      <TableCell
        onClick={() => clickToFilter('statusFilter', status)}
        sx={tableFilterOption}
      >
        {status}
      </TableCell>
      <TableCell
        onClick={() =>
          errorMeaning && clickToFilter('errorFilter', errorMeaning)
        }
        sx={errorMeaning ? tableFilterOption : undefined}
      >
        {errorMeaning || 'N/A'}
      </TableCell>
    </TableRow>
  );
};

export default MessageReportTableRow;
